export function findExistingProtocolForOfficialMatch(matches = [], officialId) {
  const officialIdStr = String(officialId || "");
  if (!officialIdStr) return null;

  return (
    (Array.isArray(matches) ? matches : []).find((match) => {
      const candidates = [
        match?.official_match_id,
        match?.officialMatchId,
        match?.official_snapshot?.id,
        match?.officialSnapshot?.id,
      ]
        .filter(Boolean)
        .map(String);

      return candidates.includes(officialIdStr);
    }) || null
  );
}

export function findSavedProtocolForMatchId(userMatches = [], matchId) {
  const matchIdStr = String(matchId || "");
  if (!matchIdStr) return null;

  return (
    (Array.isArray(userMatches) ? userMatches : []).find((userMatch) => {
      const candidates = [
        userMatch?.match_id,
        userMatch?.matchId,
        userMatch?.match?.id,
      ]
        .filter(Boolean)
        .map(String);

      return candidates.includes(matchIdStr);
    }) || null
  );
}

export function findSavedProtocolForOfficialMatch(userMatches = [], officialId) {
  const officialIdStr = String(officialId || "");
  if (!officialIdStr) return null;

  return (
    (Array.isArray(userMatches) ? userMatches : []).find((userMatch) => {
      const candidates = [
        userMatch?.official_match_id,
        userMatch?.officialMatchId,
        userMatch?.match?.official_match_id,
        userMatch?.match?.officialMatchId,
      ]
        .filter(Boolean)
        .map(String);

      return candidates.includes(officialIdStr);
    }) || null
  );
}

export function getProtocolMatchIdentity(match) {
  return {
    homeTeam: match?.home_team || match?.match_details?.home_team || "Hemmalag",
    awayTeam: match?.away_team || match?.match_details?.away_team || "Bortalag",
  };
}
